import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDblpComponent } from './simple-icons-dblp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDblpComponent ],
    exports:      [ SimpleIconsDblpComponent ],
    bootstrap:    []
})
export class SimpleIconsDblpModule {}
